import { render, staticRenderFns } from "./CustomizedDiagramPage.vue?vue&type=template&id=cb6ffc90&scoped=true&"
import script from "./CustomizedDiagramPage.vue?vue&type=script&lang=js&"
export * from "./CustomizedDiagramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6ffc90",
  null
  
)

export default component.exports